var _taggedTemplateLiteral = require("/usr/src/app/www/app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_ORDER = void 0;

var graphql_tag_1 = __importDefault(require("graphql-tag"));

var orderFragment_1 = require("../fragments/orderFragment");

exports.GET_ORDER = (0, graphql_tag_1.default)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query GET_ORDER($id: ID!) {\n    node(id: $id) {\n      ... on Order {\n        ...OrderFragment\n      }\n    }\n  }\n  ", "\n"])), orderFragment_1.ORDER_FRAGMENT);